/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DAILY_TASKS_BAR: {
        size: 45
    },
    DAILY_TASK_PROGRESS_FONT: {
        size: 38
    },
    DAILY_TASKS_TIMER_TEXT: {
        size: 43,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    DAILY_TASK_FONT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    DAILY_TASK_REWARD_FONT: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    DAILY_TASK_CTA: {
        size: 43,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksWindow, {
    tabs: {
        x: { align: "left", dx: -131 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksTab, {
    margin: 10,

    foreground: {
        width: 842,
        height: 600,
        y: { align: "center", dy: 0 }
    },

    timer: {
        padding: {
            y: 10
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTaskView, {
    margin: 20,

    padding: {
        left: 35,
        right: 35,
        top: 20,
        bottom: 20
    },

    icon: {
        x: { align: "left", dx: 60 }
    },

    title: {
        height: 80
    },

    titleAndRewards: {
        width: 394,
        height: 130,
        x: { align: "left", dx: 2 },
        y: { align: "center", dy: 3 },

        wide: {
            width: 606
        }
    },

    progressBar: {
        text: {
            dy: -2
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksCompleteAllView, {
    textLayout: {
        width: cleverapps.config.type === "merge" ? 700 : 520
    },

    prize: {
        y: { align: "bottom", dy: -14 }
    },

    prizePosition: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 16 }
    },

    padding: {
        left: 50,
        right: 50
    },

    icon: {
        dy: -10
    }
});
